import axios from "axios";

export const axiosInstance = axios.create({
  timeout: 30000, // 30 second timeout
});

// Add request interceptor for debugging (disabled for production)
axiosInstance.interceptors.request.use(
  (config) => {
    // console.log('API Request:', {
    //   method: config.method?.toUpperCase(),
    //   url: config.url,
    //   headers: config.headers,
    //   params: config.params,
    //   data: config.data
    // });
    return config;
  },
  (error) => {
    // console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging (disabled for production)
axiosInstance.interceptors.response.use(
  (response) => {
    // console.log('API Response:', {
    //   status: response.status,
    //   statusText: response.statusText,
    //   url: response.config.url,
    //   data: response.data
    // });
    return response;
  },
  (error) => {
    // console.error('API Error:', {
    //   status: error.response?.status,
    //   statusText: error.response?.statusText,
    //   url: error.config?.url,
    //   message: error.message,
    //   data: error.response?.data
    // });
    return Promise.reject(error);
  }
);

export const apiConnector = async (method, url, bodyData, headers, params, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await axiosInstance({
        method: `${method}`,
        url: `${url}`,
        data: bodyData ? bodyData : null,
        headers: headers ? headers : null,
        params: params ? params : null,
      });
      return response;
    } catch (error) {
      // If it's a 503 error and we have retries left, wait and try again
      if (error.response?.status === 503 && i < retries - 1) {
        // console.log(`503 error, retrying in ${(i + 1) * 2} seconds... (attempt ${i + 1}/${retries})`);
        await new Promise(resolve => setTimeout(resolve, (i + 1) * 2000));
        continue;
      }
      throw error;
    }
  }
};
